import React, { RefObject } from 'react';
import clsx from 'clsx';

import { SearchIcon } from '../Icon';

import {
  Foldout,
  Icon,
  Input,
  Item,
  Link,
  LinkContent,
  List,
  SearchBar,
  StyledInputSearch,
  UiBlock,
} from './wrappers';

export interface IQuerySuggestion {
  onHover: () => void;
  selected?: boolean;
  title: string;
  url: string;
}

interface IInputSearch {
  formInput?: boolean; // Add styling to fit form inputs
  onBlur?: () => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSuggestionClick?: (
    e: React.MouseEvent<HTMLAnchorElement>,
    suggestion: IQuerySuggestion,
  ) => void;
  placeholder?: string;
  inputRef?: RefObject<HTMLInputElement>;
  querySuggestion?: IQuerySuggestion[];
  title?: string;
  value?: string;
}

const InputSearch = ({
  formInput,
  onBlur,
  onChange,
  onSuggestionClick,
  placeholder,
  inputRef,
  querySuggestion,
  title,
  value,
}: IInputSearch) => (
  <StyledInputSearch>
    <SearchBar className={clsx(!!querySuggestion?.length && 'qs-open', formInput && 'form-input')}>
      <Icon>
        <SearchIcon />
      </Icon>
      <Input
        enterKeyHint="search"
        onChange={onChange}
        placeholder={placeholder ? placeholder : 'Sök'}
        ref={inputRef}
        title={title ? title : 'Sök'}
        value={value}
      />
    </SearchBar>
    {!!querySuggestion?.length && onSuggestionClick && (
      <>
        <Foldout>
          <List>
            {querySuggestion?.map((q, index) => (
              <Item key={`${q.url}-${index}`} onMouseOver={q.onHover}>
                <Link
                  href={q.url}
                  title={q.title}
                  className={clsx(q.selected && 'has-focus')}
                  onClick={(e) => onSuggestionClick(e, q)}>
                  <LinkContent>{q.title}</LinkContent>
                </Link>
              </Item>
            ))}
          </List>
        </Foldout>
        <UiBlock onClick={onBlur} />
      </>
    )}
  </StyledInputSearch>
);

export default InputSearch;
